import { CrossOutlineIcon } from './CrossOutlineIcon';

/**
 * author: Michael Irigoyen
 * id E7B0A94D-5F09-4E77-A1E0-3DA131398A26
 * name cross-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cross-outline.svg
 * tags
 * - Religion 
 */
export const ReligionChristianOutlineIcon = CrossOutlineIcon;
export default ReligionChristianOutlineIcon